import axios from "axios";
import { API_URL } from "../../constants/config";


export const getSharedItem = async (accessToken, params, postParams, dmsApiUrl) => {
  let url           = `${dmsApiUrl}get_shared_item`
  const queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, postParams, {
      headers: {
        'Content-Type': 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  } catch(err) {
    console.log(err);
  }
}

export const getStarredItem = async (accessToken, params, postParams, dmsApiUrl) => {
    let url  = `${dmsApiUrl}get_bookmark_item`;
    const queryParams = [];

    for (const [key, value] of Object.entries(params)) {
        if (value) {
        queryParams.push(`${key}=${value}`);
        }
    }

    if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`;
    }

    try {
        const response = await axios.post(url, postParams, {
        headers: {
            'Content-Type': 'application/json',
            'Dms-Token':accessToken
        }
        });
        return response.data;
    } catch(err) {
        console.log(err);
    }
}

export const postStarredItem = async(accessToken, params, postParams, dmsApiUrl) => {
  let url = `${dmsApiUrl}bookmark_item/add`;
  if(postParams.status === false) {
    url = `${dmsApiUrl}bookmark_item/delete`;
  }
  const  queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if(queryParams.length > 0 ) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, postParams, {
      headers: {
        'Content-Type' : 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  }catch(err) {
    console.log(err);
  }
}

export const getItemDetails = async (accessToken, params, postParams, dmsApiUrl) => {
  let url = `${dmsApiUrl}item_details`;
  const  queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if(queryParams.length > 0 ) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, postParams, {
      headers: {
        'Content-Type' : 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  }catch(err) {
    console.log(err);
  }
}
export const getItemActivityLogs = async (accessToken, params, postParams, dmsApiUrl) => {
  let url = `${dmsApiUrl}audit_log`;
  const  queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if(queryParams.length > 0 ) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, postParams, {
      headers: {
        'Content-Type' : 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  }catch(err) {
    console.log(err);
  }
}

export const postShareDocument = async (accessToken, params, postParams, dmsApiUrl) => {
  let url = `${dmsApiUrl}save_share_items`;
  const  queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if(queryParams.length > 0 ) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, postParams, {
      headers: {
        'Content-Type' : 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  }catch(err) {
    console.log(err);
  }
}

export const fetchDocumentTypeSection = async (accessToken, params, postParams, dmsApiUrl) => {
  let url = `${dmsApiUrl}get_document_type_section`;
  const  queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if(queryParams.length > 0 ) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, postParams, {
      headers: {
        'Content-Type' : 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  }catch(err) {
    console.log(err);
  }
}

export const postUpdateDocument = async (accessToken, params, postParams, dmsApiUrl) => {
  let url = `${dmsApiUrl}item/edit`;
  const  queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if(queryParams.length > 0 ) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, postParams, {
      headers: {
        'Content-Type' : 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  }catch(err) {
    console.log(err);
  }
}

export const downloadDocument = async (accessToken, params, postParams, dmsApiUrl) => {
  let url = postParams.download_url;
  const  queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if(queryParams.length > 0 ) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, {}, {
      headers: {
        'Content-Type' : 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  }catch(err) {
    console.log(err);
  }
}

export const uploadToAwsServer = async (accessToken, params, postParams, dmsApiUrl) => {
  try {
    let url = new URL(dmsApiUrl).origin+'/secure_multipart';
    const response      = await axios.post(url, postParams, {
      headers: {
        'Content-Type' : 'application/json'
      }
    });
    return response?.data;
  } catch(err) {
    console.log(err);
  }
}

// export const fetchChunk = async (data, chunk) => {
//   try{
//     const response = await axios.put(data.result.url, chunk, {
//       headers: {
//         'Authorization' : data.result.authHeader,
//         'x-amz-date': data.result.dateHeader
//       },
//       transformRequest: (data, headers) => {
//         delete headers['Content-Type']; // Remove Content-Type
//         return data;
//       }
//     });
//     return response?.data;
//   }catch(err){
//     console.log('Error while fetch chunk ', err);
//   }
// }


export const fetchChunk = async (data, chunk) => {
  try {
    const response = await fetch(data.result.url, {
      method: 'PUT',
      body: chunk,
      headers: {
        'Authorization': data.result.authHeader,
        'x-amz-date': data.result.dateHeader
        // Notice: No 'Content-Type' here
      }
    });

    if (!response.ok) {
      throw new Error(`Upload failed with status ${response.status}`);
    }

    return await response.text(); // or response.json() if expected
  } catch (err) {
    console.log('Error while fetch chunk', err);
  }
}


export const saveDocument = async (accessToken, params, postParams, dmsApiUrl) => {
  let url = `${dmsApiUrl}item/add`;
  const  queryParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if(queryParams.length > 0 ) {
    url += `?${queryParams.join('&')}`;
  }

  try {
    const response = await axios.post(url, postParams, {
      headers: {
        'Content-Type' : 'application/json',
        'Dms-Token':accessToken
      }
    });
    return response.data;
  }catch(err) {
    console.log(err);
  }
}

export const generateAuthToken = async (accessToken) => {
  let url = `${API_URL}ops/api/generate-auth-token`;
  try {
    const response = await axios.get(url, {
      headers: {
        'Content-Type' : 'application/json',
        'Authorization': `Bearer ${accessToken}`
      }
    });
    return response.data.data.dms.access_token.data.token;
  }catch(err) {
    console.log(err);
  }
}
